
const base = 1.05
const scale = 1.14

export const FontScale = {
    size_1: `${base}rem`, 
    size_2: `${base * scale}rem`,
    size_3: `${base * Math.pow(scale, 2)}rem`, 
    size_4: `${base * Math.pow(scale, 3)}rem`, 
    size_5: `${base * Math.pow(scale, 4)}rem`, 
    size_6: `${base * Math.pow(scale, 5)}rem`, 
}
